import React from 'react';

export function ChartCard({ title, subtitle, children, height = '300px' }) {
  return (
    <div className="bg-white dark:bg-slate-900 rounded-lg border border-gray-200 dark:border-slate-700 p-6 shadow-sm">
      <div className="mb-4">
        <h3 className="text-sm font-semibold text-gray-900 dark:text-white">{title}</h3>
        {subtitle && <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">{subtitle}</p>}
      </div>
      <div style={{ height }}>
        {children}
      </div>
    </div>
  );
}
